import { render, staticRenderFns } from "./EmularUser.vue?vue&type=template&id=4a38f841&scoped=true&"
import script from "./EmularUser.vue?vue&type=script&lang=js&"
export * from "./EmularUser.vue?vue&type=script&lang=js&"
import style0 from "./EmularUser.vue?vue&type=style&index=0&id=4a38f841&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38f841",
  null
  
)

export default component.exports